// src/awsConfig.js
const awsConfig = {
  region: process.env.REACT_APP_AWS_REGION,
  UserPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
  ClientId: process.env.REACT_APP_AWS_CLIENT_ID,
};

console.log('AWS Config:', awsConfig); // Add this line to verify the values
export default awsConfig;
